import routeParams from 'helpers/routeParams'
import { mapAllowedRoles } from 'helpers/mapForSelect'
import _ from 'lodash'

const CONTACTS = 'dofe-bo/contacts/CONTACTS'
const CONTACTS_SUCCESS = 'dofe-bo/contacts/CONTACTS_SUCCESS'
const CONTACTS_FAIL = 'dofe-bo/contacts/CONTACTS_FAIL'
const CONTACT = 'dofe-bo/contacts/CONTACT'
const CONTACT_SUCCESS = 'dofe-bo/contacts/CONTACT_SUCCESS'
const CONTACT_FAIL = 'dofe-bo/contacts/CONTACT_FAIL'
const ACTIVE_CONTACT = 'dofe-bo/contacts/ACTIVE_CONTACT'
const ACTIVE_CONTACT_SUCCESS = 'dofe-bo/contacts/ACTIVE_CONTACT_SUCCESS'
const ACTIVE_CONTACT_FAIL = 'dofe-bo/contacts/ACTIVE_CONTACT_FAIL'
const CONTACT_DETAIL_RESET = 'dofe-bo/contacts/CONTACT_DETAIL_RESET'
const CREATE_CONTACT = 'dofe-bo/contacts/CREATE_CONTACT'
const CREATE_CONTACT_SUCCESS = 'dofe-bo/contacts/CREATE_CONTACT_SUCCESS'
const CREATE_CONTACT_FAIL = 'dofe-bo/contacts/CREATE_CONTACT_FAIL'
const DELETE_CONTACT = 'dofe-bo/contacts/DELETE_CONTACT'
const DELETE_CONTACT_SUCCESS = 'dofe-bo/contacts/DELETE_CONTACT_SUCCESS'
const DELETE_CONTACT_FAIL = 'dofe-bo/contacts/DELETE_CONTACT_FAIL'
const UPDATE_CONTACT = 'dofe-bo/contacts/UPDATE_CONTACT'
const UPDATE_CONTACT_SUCCESS = 'dofe-bo/contacts/UPDATE_CONTACT_SUCCESS'
const UPDATE_CONTACT_FAIL = 'dofe-bo/contacts/UPDATE_CONTACT_FAIL'
const ALLOWED_ROLES = 'dofe-bo/contacts/ALLOWED_ROLES'
const ALLOWED_ROLES_SUCCESS = 'dofe-bo/contacts/ALLOWED_ROLES_SUCCESS'
const ALLOWED_ROLES_FAIL = 'dofe-bo/contacts/ALLOWED_ROLES_FAIL'
const SET_FILTER = 'dofe-bo/contacts/SET_FILTER'
const SET_PARAMS = 'dofe-bo/contacts/SET_PARAMS'

const initialState = {
  list: [],
  detail: {},
  active: {},
  allowedRoles: [],
  sort: '',
  offset: 0,
  limit: 20,
  pages: 1,
  count: null,
  filter: '',
  invalidate: null,
  loading: false,
  loaded: false
}

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case CONTACTS:
      return {
        ...state,
        loading: true
      }
    case CONTACTS_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
        list: action.result,
        count: action.headers['x-total-count'],
        pages:
          Math.ceil(Number(action.headers['x-total-count']) / state.limit) ||
          state.pages
      }
    case CONTACTS_FAIL:
      return {
        ...state,
        loading: false,
        loaded: false,
        error: action.error
      }
    case CONTACT:
      return {
        ...state,
        loading: true
      }
    case CONTACT_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
        detail: action.result[0]
      }
    case CONTACT_FAIL:
      return {
        ...state,
        loading: false,
        loaded: false,
        error: action.error
      }
    case ACTIVE_CONTACT:
      return {
        ...state,
        loading: true
      }
    case ACTIVE_CONTACT_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
        active: action.result[0]
      }
    case ACTIVE_CONTACT_FAIL:
      return {
        ...state,
        loading: false,
        loaded: false,
        error: action.error
      }
    case CONTACT_DETAIL_RESET:
      return {
        ...state,
        loading: false,
        loaded: false,
        detail: {}
      }
    case ALLOWED_ROLES:
      return {
        ...state,
        loading: true
      }
    case ALLOWED_ROLES_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
        allowedRoles: mapAllowedRoles(action.result)
      }
    case ALLOWED_ROLES_FAIL:
      return {
        ...state,
        loading: false,
        loaded: false,
        error: action.error
      }
    case SET_FILTER:
      return Object.assign({}, state, {
        filter: action.filterBy,
        invalidate: new Date().getTime()
      })
    case SET_PARAMS:
      return {
        ...state,
        limit:
          action.options.limit !== undefined
            ? action.options.limit
            : state.limit,
        offset:
          action.options.offset !== undefined
            ? action.options.offset
            : state.offset,
        filter:
          action.options.filter !== undefined
            ? action.options.filter
            : state.filter,
        sort:
          action.options.sort !== undefined
            ? action.options.sort
            : state.sort,
        invalidate: _.isEmpty(action.options)
          ? state.invalidate
          : new Date().getTime()
      }
    default:
      return state
  }
}

export function getOrganizationContacts(id, params = {}, baseFilter, { onlyActive } = {}) {
  if (onlyActive) {
    if(baseFilter){
      baseFilter = `${baseFilter},person.personState.value=ACTIVE`
    } else {
      baseFilter = `person.personState.value=ACTIVE`
    }
  }

  return {
    types: [CONTACTS, CONTACTS_SUCCESS, CONTACTS_FAIL],
    promise: client =>
      client.get(
        `api/organizations/${id}/contacts?with=PERSON,PERSON_ADDRESS${routeParams(
          params,
          baseFilter
        )}`
      )
  }
}

export function getOrganizationContact(organizationId, contactId) {
  return {
    types: [CONTACT, CONTACT_SUCCESS, CONTACT_FAIL],
    promise: client =>
      client.get(
        `api/organizations/${organizationId}/contacts?with=PERSON,PERSON_ADDRESS&filter=id=${contactId}`
      )
  }
}

export function getOrganizationContactForActiveUser(organizationId, userId) {
  return {
    types: [ACTIVE_CONTACT, ACTIVE_CONTACT_SUCCESS, ACTIVE_CONTACT_FAIL],
    promise: client =>
        client.get(
            `api/organizations/${organizationId}/contacts?with=PERSON,PERSON_ADDRESS&filter=person.id=${userId}`
        )
  }
}

export function createOrganizationContact(organizationId, data) {
  return {
    types: [CREATE_CONTACT, CREATE_CONTACT_SUCCESS, CREATE_CONTACT_FAIL],
    promise: client =>
      client.post(`api/organizations/${organizationId}/organization-contacts`, {
        data
      })
  }
}

export function clearOrganizationContactDetail() {
  return {
    type: CONTACT_DETAIL_RESET
  }
}

export function updateOrganizationContact(id, data) {
  return {
    types: [UPDATE_CONTACT, UPDATE_CONTACT_SUCCESS, UPDATE_CONTACT_FAIL],
    promise: client =>
      client.put(`api/organization-contacts/${id}?update=PERSON`, {
        data
      })
  }
}

export function deleteOrganizationContact(id, { reason } = {}) {
  const reasonQuery = reason ? `?reason=${reason}` : ''

  return {
    types: [DELETE_CONTACT, DELETE_CONTACT_SUCCESS, DELETE_CONTACT_FAIL],
    promise: client =>
      client.del(`api/organization-contacts/${id}${reasonQuery}`)
  }
}

export function getOrganizationContactAllowedRoles(contactId, organizationId) {
  return {
    types: [ALLOWED_ROLES, ALLOWED_ROLES_SUCCESS, ALLOWED_ROLES_FAIL],
    promise: client =>
      client.get(
        `api/organization-contacts/${contactId}/allowed-roles?rolesForOrganizationId=${organizationId}`
      )
  }
}

export function setContactsFilter(filterBy) {
  return {
    type: SET_FILTER,
    filterBy
  }
}

export function setOrganizationContactsParams(options) {
  return {
    type: SET_PARAMS,
    options
  }
}
